<material-select-article [variation-id]="null"
                         [groups]="groups.objects"
                         level="1"
                         (group)="setCurrentGroup($event)">
</material-select-article>
